
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    CM: "CM",
    DA: "DA",
    DE: "DE",
    FM: "FM",
    FT: "FT",
    HM: "HM",
    HF: "HF",
    HY: "HY",
    IN: "IN",
    LM: "LM",
    KM: "KM",
    NM: "NM",
    MR: "MR",
    MI: "MI",
    MM: "MM",
    MF: "MF",
    YD: "YD"
};
